import { Navigate } from 'react-router-dom';
import { useTier } from '../contexts/TierContext';

/**
 * EPIC-15 (PLG): an account is live the moment the email is verified — free
 * Pro needs no subscription and no card. This wrapper now only requires a
 * signed-in user whose account actually exists and is in a usable state; it
 * no longer bounces people to a card step (there is none). A stale legacy
 * 'pending_signup' account (pre-migration) is sent to /signup, where the
 * wizard resumes and finishes without payment.
 */
function accountIsLive(account: any): boolean {
  if (!account) return false;
  const status = account.status;
  const effective = account.effectiveStatus;
  return (
    status === 'pro' ||
    effective === 'pro' ||
    status === 'trial' ||
    effective === 'trial' ||
    account.subscriptionStatus === 'active' ||
    !!account.subscriptionId
  );
}

interface ProtectedRouteProps {
  children: React.ReactNode;
  user: any;
}

export function ProtectedRoute({ children, user }: ProtectedRouteProps) {
  const { account, loading } = useTier();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (loading) {
    return (
      <div className="app">
        <div className="loading">
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  if (!accountIsLive(account)) {
    return <Navigate to="/signup" replace />;
  }

  return <>{children}</>;
}
